var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: "所属组织" } },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "268px" },
          attrs: {
            multiple: "",
            filterable: "",
            remote: "",
            "collapse-tags": "",
            "remote-method": _vm.remoteMethod,
            placeholder: "全部",
            loading: _vm.loading,
            "popper-append-to-body": false,
            clearable: "",
          },
          on: { "remove-tag": _vm.handleRemoveTag, clear: _vm.clearAll },
          model: {
            value: _vm.selectVal,
            callback: function ($$v) {
              _vm.selectVal = $$v
            },
            expression: "selectVal",
          },
        },
        [
          _c(
            "el-option",
            {
              staticStyle: { height: "100%", padding: "0" },
              attrs: { value: "" },
            },
            [
              _c("el-tree", {
                ref: "tree",
                staticStyle: { width: "100%", padding: "10px 20px 10px 0" },
                attrs: {
                  "show-checkbox": "",
                  data: _vm.options,
                  props: _vm.defaultProps,
                  "highlight-current": "",
                  "expand-on-click-node": true,
                  "node-key": "code",
                  "default-checked-keys": _vm.defaultKeys,
                  "filter-node-method": _vm.filterNode,
                },
                on: { "check-change": _vm.handleNodeChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }